import script from "./general-survey.vue?vue&type=script&setup=true&lang=js"
export * from "./general-survey.vue?vue&type=script&setup=true&lang=js"

import "./general-survey.vue?vue&type=style&index=0&id=6ef443f8&lang=scss"

const __exports__ = script;

export default __exports__